export default "__VITE_ASSET__d506ed24__"